/** Inline loading spinner (U5). Sized in `em` so it follows text size. */
import type { JSX } from 'react';
import { cx } from './cx';

export interface SpinnerProps {
  className?: string;
  /** Pixel size override; defaults to 1em of the parent. */
  size?: number;
  label?: string;
}

export function Spinner({ className, size, label }: SpinnerProps): JSX.Element {
  return (
    <span
      className={cx('bl-spinner', className)}
      style={size ? { width: size, height: size } : undefined}
      role="status"
      aria-label={label ?? 'Loading'}
    />
  );
}
